<template>
  <b-modal id="modalNewCard" :ref="refName" :hide-footer="true">
    <div slot="modal-title" v-translate>Enter a new payment method</div>
    <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.prevent="handleCC" ref="CCForm">
        <div class="card-wrapper">
        </div>
        <b-row>
          <div class="form-group col-12"><br>
            <b-form-input name="reference" :placeholder="$gettext('Card reference name')" type="text" v-model="cardDetail.reference" required />
          </div>
          <div class="form-group col-12">
            <b-form-input name="name" :placeholder="$gettext('Full name')" type="text" v-model="cardDetail.name" v-card-focus required />
          </div>
          <div class="form-group col-12">
            <b-form-input name="dni" :placeholder="$gettext('ID card')" type="text" v-model="cardDetail.payer_dni" required />
          </div>
          <div class="form-group col-12">
            <b-form-input name="number" :placeholder="$gettext('Card number')" type="tel" v-model="cardDetail.number" v-card-focus required />
          </div>
          <div class="form-group col-6">
            <b-form-input name="expiry" :placeholder="$gettext('MM/YY')" type="tel" v-model="cardDetail.expiry" v-card-focus class="col-6" required />
          </div>
          <div class="form-group col-6">
            <b-form-input name="cvc" :placeholder="$gettext('CVC')" type="number" v-model="cardDetail.cvc" v-card-focus class="col-6" required />
          </div>
        </b-row>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Submit</b-button>
          <b-button type="reset" variant="outline-primary" size="lg" @click="hideModal" v-translate>Cancel</b-button>
        </div>
      </b-form>
  </b-modal>
</template>
<script>
import { PAYMENT_METHOD_CREATE } from '@/store/actions.type'

const defaultProps = {
  reference: '',
  payer_dni: '',
  number: '',
  name: '',
  expiry: '',
  cvc: '',
  is_default: false,
  country_iso_code: 'AR'
}
const resetProps = JSON.parse(JSON.stringify(defaultProps))

export default {
  name: 'PaymentMethodForm',
  // components: {
  //   card
  // },
  data() {
    return {
      cardDetail: defaultProps,
      resetProps: {},
      translations: [
        this.$gettext('Full Name'),
        this.$gettext('Card reference name'),
        this.$gettext('Full name'),
        this.$gettext('ID card'),
        this.$gettext('Card number'),
        this.$gettext('MM/YY'),
        this.$gettext('CVC')
      ]
    }
  },
  props: {
    refName: {
      type: String,
      required: true,
      default: 'PaymentMethodForm'
    },
    markAsDefault: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.markAsDefault) {
      this.cardDetail.is_default = true
    }
  },
  methods: {
    handleCC(evt) {
      evt.preventDefault()

      let cc = this.cardDetail
      cc.cc_number = parseInt(cc.number.replace(/\s/g, ''))
      cc.payer_name = cc.name
      cc.cc_name = this.$refs.argh.cardType.toUpperCase()
      cc.cvv = cc.cvc

      let ccDate = cc.expiry.replace(/\s/g, '').split('/')
      let ccYear = ccDate[1].length === 2 ? '20' + ccDate[1] : ccDate[1]
      cc.cc_number_expiration_date = ccYear + '/' + ccDate[0]

      cc.payer_id = this.$store.getters.uid

      this.$store.dispatch(PAYMENT_METHOD_CREATE, cc).then(response => {
        if (response.ok) {
          this.$emit('success', true)
          this.cardDetail = JSON.parse(JSON.stringify(resetProps))
          this.$refs[this.refName].hide()
        }
      }, error => {
        let mssg = ''
        if (typeof error.body.errors !== 'undefined') {
          for (let i = 0; i < error.body.errors.length; i++) {
            mssg += error.body.errors[i].detail + '<br>'
          }
        } else {
          mssg = error.body.message
        }
        let obj = {
          title: 'ERROR',
          message: mssg,
          type: 'error',
          customCloseBtnText: this.$gettext('Close')
        }
        console.log(this.$root)
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      })
    },
    hideModal() {
      this.cardDetail = JSON.parse(JSON.stringify(resetProps))
      this.$refs[this.refName].hide()
    }
  }
}

</script>
